import React from 'react';
import { useNieve } from '../../context/NieveContext';
import './LogoInvierno.css';

// Escena invernal junto al logo (vacaciones de invierno, reemplaza al hincha
// del Mundial): mochila, orejeras, taza de cacao con vapor, gorro rosa y pinos.
// Es el sprite animado extraído del video nieve.mp4 (Gemini/Veo, generado a
// partir del banner que pasó el cliente) con _assets_originales/make_nieve_sprite.py.
const PUB = process.env.PUBLIC_URL;

const prefersReduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const LogoInvierno = () => {
  const { setActiva } = useNieve();
  return (
    <span
      className="logo-invierno"
      aria-hidden="true"
      onMouseEnter={() => setActiva(true)}
      onMouseLeave={() => setActiva(false)}
    >
      <img
        src={`${PUB}/img/${prefersReduced ? 'invierno_escena_static.png' : 'invierno_escena.webp'}`}
        alt=""
      />
    </span>
  );
};

export default LogoInvierno;
